/* @flow */
import Notice from 'components/Notice.jsx';
import * as React from 'react';
import Toast from 'components/Toast.jsx';

/**
 * ## [Toast](/internal/components/Toast) that surfaces a [Notice](/internal/components/Notice) to show that something has successfully happened.
 * ### Used as an unintrusive way to alert the user of the successful result of an action they took.
 *
 * ```example
 * <SuccessToast>
 *   SuccessToast
 * </SuccessToast>
 * ```
 *
 *
 * # TODO
 * * Consider combining with [Toast](/internal/components/Toast)
 */

const SuccessToast = (props: { children: string }) => (
  <Toast>
    <Notice color="shamrock" glyph="check">
      {props.children}
    </Notice>
  </Toast>
);

export default SuccessToast;
